import React, { useEffect } from "react";
import "./../Usuarios/usuarios.css";

import { SubSections } from "../../data/navItem";
import ClientesCatalogo from "./ClientesCatalogo";
import ClientesDashboard from "./ClientesDashboard";

export default function Clientes({ subSectionId }) {
  const fetchData = async () => {};

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {subSectionId === SubSections.Dashboard && <ClientesDashboard />}
      {subSectionId === SubSections.Catalogo && <ClientesCatalogo />}
    </>
  );
}
